export default class OverlayIconsToHide extends Phaser.Group {
  constructor(game, playerIcon, playerNr, characterIcons) {
    super(game);

    this.onEnd = new Phaser.Signal();

    // background
    // this.bg = this.game.make.image(0, 0, this.game.controller.location);
    this.bg = this.game.make.image(0, 0, 'bg_location_' + this.game.controller.location);
    this.addChild(this.bg);

    // character icon
    this.icon = playerIcon;
    this.icon.x = this.game.defaultWidth / 2;
    this.icon.y = 165;
    this.icon.scale.set(1);
    this.addChild(this.icon);

    // character icons
    this.characterIcons = characterIcons;
    this.iconsY = this.characterIcons.y;
    this.characterIcons.x = this.game.defaultWidth / 2;
    this.characterIcons.y = 425;
    this.characterIcons.scale.set(1.5);
    this.characterIcons.setArrowsVisibility(false);
    this.addChild(this.characterIcons);

    //
    if (playerNr === 1) {
      // for player 1
      this.game.twoPlayersOnboarding.playVOs(['ob_05_elinor_015']);
    } else {
      // for player 2
      this.game.twoPlayersOnboarding.playVOs(['ob_05_elinor_026']);
    }
    this.game.twoPlayersOnboarding.onEnd.addOnce(this.transitionOut, this);
  }

  transitionOut() {
    this.game.add.tween(this.bg).to({ alpha: 0 }, 500, null, true);

    const time = 700;

    const x0 = (this.game.defaultWidth - this.game.width) / 2 + 25;
    const y0 = 640;
    this.game.add.tween(this.icon).to({ x: x0, y: y0 }, time, null, true);
    this.game.add.tween(this.icon.scale).to({ x: 0.8, y: 0.8 }, time, null, true);
    this.icon.animateToHudMode(time);

    this.game.add.tween(this.characterIcons.scale).to({ x: 1, y: 1 }, time, null, true);
    this.game.add
      .tween(this.characterIcons)
      .to({ y: this.iconsY }, time, null, true)
      .onComplete.add(this.handelAnimEnd, this);
  }

  handelAnimEnd() {
    this.characterIcons.setArrowsVisibility(true);
    this.onEnd.dispatch();
  }
}
